<template>
  <div class="messages">
    <div
      v-for="message in messages"
      :key="message.id"
      class="message"
      @click.prevent="remove(message.id)"
    >
      {{ message.message }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["messages"])
  },
  methods: {
    remove(id) {
      this.$store.dispatch("deleteMessage", id);
    }
  }
};
</script>
